<template>
<div :style="{'height':height, 'width':width}">
    <label v-if="label!==null">
        {{ label }}
        <span style="color:red">
            {{ required ? '*' : '' }}
        </span>
    </label>
    <input
        type="email"
        class="form-control"
        :class="[{'is-invalid': !isValid}]"
        :placeholder="placeholder"
        v-model="input"
        :maxlength="maxlength"
        :required="required"
        :disabled="disabled || !enableComponent"
        :readonly="readOnly"
        @click="onClick"
        @change="onChange"
        @focus="onFocus"
        @blur="onBlur"
        @keyup="onKeyPress"
        @keypress.enter.prevent="onKeyPressEnter"
        @keydown.tab="onKeyDownTab"
        :autocomplete="autocomplete"
    >
    <div class="invalid-feedback" style="display:block !important" v-for="error of errors">{{ error }}</div>
</div>
</template>
        
<script>
import checkPermissions from '../../../mixins/checkPermissions';
export default {
    name:'input-email',
    mixins: [checkPermissions],
    props:{
        dataSource:             {type: String,  default: null},
        defaultValue:           {},
        height:                 {type: String, default: "100%"},
        width:                  {type: String, default: "100%"},
        label:                  {type: String, default: null},
        required:               {type: Boolean, default: false},
        disabled:               {type: Boolean, default: false},
        placeholder:            {type: String, default:""},
        autocomplete:           {type: String, default: "new-password"},
        readOnly:               {type: Boolean, default: false},
        maxlength:              {type: Number, default: 50}
    },
    computed:{
        isValid(){
            return this.errors.length == 0;
        },
        inputType() {
            return this.$parent.type;
        },
        input: {
            get() {
                if (this.dataSource == null) return this.l_input;
                if (this.inputType === 'list') {
                    let val = this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
                    return val;
                } else {
                    let val = this.$parent.data_provider_ref[this.inputType][this.dataSource];
                    return val;
                }
            },
            set(newval) {
                if(this.dataSource !== null){
                    if (this.inputType === 'list') {
                        this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, newval);
                    } else {
                        this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, newval);
                    }
                }else{
                    this.l_input = newval;
                }
            }
        }
    },
    methods:{
        validate_input(){
            this.errors = [];
            if (this.required) {
                if (!this.input || `${this.input}`.length == 0) {
                    this.errors.push('This Field is Required');
                    return false
                }
            }
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(!re.test(String(this.input).toLowerCase())){
                this.errors.push('The field must be a valid e-mail');
                return false
            }
            return true;
        },
        onKeyPress()        { this.$emit('onKeyPress', this); },
        onKeyPressEnter()   { this.$emit('onKeyPressEnter', this); },
        onKeyDownTab()      { this.$emit('onKeyDownTab', this); },
        onBlur()            { this.$emit('onBlur', this); },
        onFocus()           { this.$emit('onFocus', this); },
        onClick()           { this.$emit('onClick', this); },
        onChange()          { this.$emit('onChange', this); },
    },
    mounted() {
        if (typeof this.defaultValue !== 'undefined') this.input = this.defaultValue;
        if (this.dataSource !== null) this.$parent.data_provider_ref.inputs[this.dataSource] = this; 
        this.$emit('onMounted', this);
    },
    data(){
        return{
            l_input: null,
            errors: []
        }
    }
}
</script>